import _regenerator from "/var/jenkins_home/workspace/crm-admin-uat/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/crm-admin-uat/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import welcomeBackIcon from '@/assets/svgs/welcome_back_icon.svg';
export default {
  name: 'WelcomeBack',
  data: function data() {
    return {
      dialogVisible: true,
      msg: '',
      welcomeBackIcon: welcomeBackIcon
    };
  },
  methods: {
    close: function close() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this.dialogVisible = false;
              window.location.reload();
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }))();
    }
  }
};